import TableBody from "./TableBody";
import TableHead from "./TableHead";
import { Table } from "react-bootstrap";
import { useSortableTable } from "../../../hooks/useSortableTable";
import useStickyHeader from "../../../hooks/useStickyHeader";

const RecentLoginsTable = ({ data, columns, currentPage, pageLimit }) => {
  const [tableData, handleSorting] = useSortableTable(data, columns);
  const { tableRef, stickyStyle } = useStickyHeader();

  return (
    <>
      <Table responsive striped className="table-container" ref={tableRef}>
        <TableHead {...{ columns, handleSorting, stickyStyle }} />
        <TableBody {...{ columns, tableData, currentPage, pageLimit }} />
      </Table>
    </>
  );
};

export default RecentLoginsTable;
